module.exports = __webpack_public_path__ + "static/media/B_modern_edge.16bf98ee.png";